// LazyImage.js
import React, { useState } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";
import Skeleton from "@mui/material/Skeleton";

const StyledImg = styled('img')(({ theme }) => ({
    width: '100%',
    height: 'auto',
    display: 'block',
}));

const LazyImage = ({ src, alt, mockHeight = 150, ...rest }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <Box position="relative" width="100%">
            {!loaded && (
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={mockHeight}
                    animation="wave"
                />
            )}
            <StyledImg
                src={src}
                alt={alt}
                onLoad={() => setLoaded(true)}
                style={{ display: loaded ? 'block' : 'none' }}
                {...rest}
            />
        </Box>
    );
};

export default LazyImage;
